import ClassroomList from "./components/List"
import ClassroomForm from "./components/Form"
import ClassroomView from "./components/View"

let module = "classrooms"

export default [
  { path: "classrooms", component: ClassroomList, meta: { module: module, permissions: ["classroom-access"] } },
  {
    path: "classrooms/create",
    component: ClassroomForm,
    props: true,
    meta: { module: module, permissions: ["classroom-create"] }
  },
  {
    path: "classrooms/edit/:id",
    component: ClassroomForm,
    props: true,
    meta: { module: module, permissions: ["classroom-edit"] }
  },
  {
    path: "classrooms/view/:id",
    component: ClassroomView,
    props: true,
    meta: { module: module, permissions: ["classroom-access"] }
  }
]
